
import { Component, Prop, Vue } from 'vue-property-decorator';
import { brandLogo, brandMark, brandName } from '@/utils/brand';

export interface IPanelRow {
  icon: string;
  title: string;
  text?: string;
}
export interface IPanelStat {
  value: string;
  label: string;
}

@Component({
  name: 'AuthLayout',
})
export default class AuthLayout extends Vue {
  /* brand mark and name, overridable per whitelabel from build-time env */
  get brandLogo(): string {
    return brandLogo();
  }

  get brandName(): string {
    return brandName();
  }

  get brandMark(): string {
    return brandMark();
  }
  @Prop({ default: 'Customer Dashboard' }) badge!: string;
  @Prop({ default: 'Reach your customers in moments.' }) headline!: string;
  @Prop({
    default:
      'Bulk SMS, USSD and voice campaigns — one dashboard for every message you send across the world.',
  })
  lead!: string;
  @Prop({ default: () => [] }) rows!: IPanelRow[];
  @Prop({ default: () => [] }) stats!: IPanelStat[];
  @Prop({ default: false }) wide!: boolean;

  get year(): number {
    return new Date().getFullYear();
  }
}
